import React, { useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'
import { Workbook } from 'exceljs'
import { isObjectValid } from '../common/utils/validate';
import ManagePackageService from '../services/ManagePackageService';
import Loading from '../components/loading/Loading';
import SweetAlert2 from 'react-sweetalert2';
import { useNavigate } from 'react-router-dom';

function ManagePackage() {
    
    const navigate = useNavigate()

    const refInputFile = useRef();

    const [dataImports, setDataImports] = useState([])

    const [dataInput, setDataInput] = useState({
        file: '',
        packageType: '',
        unit: '',
        value: ''
    })

    const [resultTopup, setResultTopup] = useState({})

    const [isLoading, setIsLoading] = useState(false)
    const [swalProps, setSwalProps] = useState({});


    return (
        <div className='home-body font-link '>

            <Container>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ระบุเงื่อนไขการจัดการแพ็คเกจ</label>
                                <Row className='mt-4' style={{ alignItems: 'center' }}>
                                    <Col xs={2} >
                                        <label>อัพโหลด</label>
                                    </Col>
                                    <Col xs={4} >
                                        <Form.Group controlId="formFile">
                                            <Form.Control
                                                ref={refInputFile}
                                                // value={dataInput.file}
                                                type="file" onChange={(e) => {
                                                    setDataInput(prevState => ({
                                                        ...prevState, file: e.target.files[0].name
                                                    }))

                                                    importExcel(e)
                                                }} />
                                        </Form.Group>
                                    </Col>
                                    <Col>

                                        <Button variant="success"
                                            onClick={() => {
                                                onDownloadTemplate()
                                            }}
                                        >Template</Button>

                                        {/* <Button variant="primary"
                                            onClick={() => {
                                                onDownloadTemplate()
                                            }}
                                        >Template Excel</Button> */}
                                    </Col>
                                </Row>

                                <Row className='mt-4' style={{ alignItems: 'center' }}>

                                    <Col xs={2}>
                                        <label>Package</label>
                                    </Col>
                                    <Col xs={2}>
                                        <Form.Select
                                            defaultValue={dataInput.packageType}
                                            onChange={(e) => {

                                                let val = ''
                                                if (e.target.value !== 'กรุณาเลือก') {
                                                    val = e.target.value
                                                }
                                                setDataInput(prevState => ({
                                                    ...prevState, packageType: val
                                                }))

                                            }}
                                        >
                                            <option selected={dataInput.packageType === '' ? true : false}>กรุณาเลือก</option>
                                            <option value="Plus">Plus</option>
                                            <option value="Farm">Farm</option>
                                        </Form.Select>
                                    </Col>

                                    <Col xs={2}>
                                        <label>หน่วยของระยะเวลา</label>
                                    </Col>
                                    <Col xs={2}>
                                        <Form.Select
                                            defaultValue={dataInput.unit}
                                            onChange={(e) => {

                                                let val = ''
                                                if (e.target.value !== 'กรุณาเลือก') {
                                                    val = e.target.value
                                                }
                                                setDataInput(prevState => ({
                                                    ...prevState, unit: val
                                                }))

                                            }}
                                        >
                                            <option selected={dataInput.unit === '' ? true : false}>กรุณาเลือก</option>
                                            <option value="Day">Day</option>
                                            <option value="Month">Month</option>
                                            <option value="Year">Year</option>
                                        </Form.Select>
                                    </Col>

                                    <Col xs={2}>
                                        <label>จำนวน</label>
                                    </Col>
                                    <Col xs={1}>
                                        <Form.Control
                                            value={dataInput.value}
                                            type='number'

                                            onChange={(e) => {
                                                let val = ''
                                                if (e.target.value !== '') {
                                                    val = e.target.value
                                                }
                                                setDataInput(prevState => ({
                                                    ...prevState, value: val
                                                }))
                                            }}
                                        />
                                    </Col>


                                </Row>

                                <Row className='mt-4'>
                                    <div style={{ flexDirection: 'row' }}>

                                        <Button variant="primary" onClick={(e) => {

                                            onSubmit()

                                        }}>Confirm</Button>


                                        <Button style={{ marginLeft: 10 }} variant="outline-secondary" onClick={() => {
                                            onReset()
                                        }}>Reset</Button>

                                    </div>

                                </Row>

                                {/* <Row>
                                    <Col xs={2}>
                                        <Button variant="primary" onClick={() => {
                                            onSubmit()
                                        }}>Confirm</Button>
                                    </Col>
                                    <Col xs={2}>
                                        <Button variant="outline-secondary" onClick={() => {
                                            onReset()

                                        }}>Reset</Button>

                                    </Col>
                                </Row> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {(isObjectValid(dataImports) && !isObjectValid(resultTopup)) &&
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>

                                    <Row>
                                        <Row>
                                            <Col>
                                                <label>จำนวนทั้งหมด {dataImports.length}</label>
                                            </Col>

                                        </Row>
                                        <Col className='mt-3'>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Username</th>
                                                        <th>From</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataImports.map((item, index) => {

                                                        return (
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td>{item.Username}</td>
                                                                <td>{item.From}</td>
                                                                <td>{item.status}</td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                }

                {isObjectValid(resultTopup) &&
                    <div>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>

                                        <Row>
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >สำเร็จ จำนวนทั้งหมด {resultTopup.usernames.length} </label>
                                                </Col>
                                                <Col xs={1}>
                                                    <Button variant="primary" onClick={() => {

                                                        onExportSuccess()

                                                    }}>Export</Button>
                                                </Col>
                                            </Row>
                                            <Col className='mt-4'>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Username</th>
                                                            <th>From</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {resultTopup.usernames.map((item, index) => {

                                                            return (
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.username}</td>
                                                                    <td>{item.from}</td>
                                                                    <td>Successful</td>
                                                                </tr>
                                                            )
                                                        })}

                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>

                                        <Row>
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ไม่สำเร็จ จำนวนทั้งหมด {resultTopup.usernamesFail.length} </label>
                                                </Col>
                                                <Col xs={1}>
                                                    <Button variant="primary" onClick={() => {
                                                        onExportFail()
                                                    }}>Export</Button>
                                                </Col>
                                            </Row>
                                            <Col className='mt-4'>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Username</th>
                                                            <th>From</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {resultTopup.usernamesFail.map((item, index) => {

                                                            return (
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.username}</td>
                                                                    <td>{item.from}</td>
                                                                    <td>Fail</td>
                                                                </tr>
                                                            )
                                                        })}

                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                }
            </Container>

            <Loading isShow={isLoading} />
            <SweetAlert2 {...swalProps}

                didClose={() => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}

                onConfirm={result => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}


            />

        </div>
    )

    function onExportSuccess() {

        // let arrayDatas = []




        let workbook = new Workbook()
        let worksheet = workbook.addWorksheet('Template')

        var headerTexts = ['#','Username', 'From', 'Status']

        worksheet.getRow(1).values = headerTexts

        resultTopup.usernames.forEach((item, index) => {

            worksheet.getRow(index + 2).values = [(index+1),item.username, item.from, 'Successful']
        })



        workbook.xlsx.writeBuffer().then(data => {
            let blob = new Blob([data], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            fs.saveAs(blob, 'PackageSuccess')
        })

    }
    function onExportFail() {

        let workbook = new Workbook()
        let worksheet = workbook.addWorksheet('Template')

        var headerTexts = ['#','Username', 'From', 'Status']

        worksheet.getRow(1).values = headerTexts

        resultTopup.usernamesFail.forEach((item, index) => {

            worksheet.getRow(index + 2).values = [(index+1),item.username, item.from, 'Fail']
        })


        workbook.xlsx.writeBuffer().then(data => {
            let blob = new Blob([data], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            fs.saveAs(blob, 'PackageFail')
        })
    }

    function onReset() {

        setDataImports([])
        setDataInput({
            file: '',
            packageType: '',
            unit: '',
            value: ''
        })
        setResultTopup({})

        refInputFile.current.value = '';


    }

    function onSubmit() {

        if (dataInput.packageType !== '' && dataInput.unit !== '' && dataInput.value !== '' && dataInput.value !== '0') {
            let result = dataImports.filter(q => q.status === 'NotReady')

            if (dataImports.length !== 0 && result.length === 0) {
                topupPackage()
            }
            else if (dataImports.length !== 0) {
                setSwalProps({
                    show: true,
                    icon: 'info',
                    html: 'กรุณาอัพโหลดไฟล์ให้ถูกต้อง',
                    showConfirmButton: true,
                    confirmButtonColor: '#0d6efd',
                    confirmButtonText: 'OK',
                });
            }
            else {
                setSwalProps({
                    show: true,
                    icon: 'info',
                    html: 'กรุณาแก้ไขไฟล์ Excel ให้ถูกต้อง',
                    showConfirmButton: true,
                    confirmButtonColor: '#0d6efd',
                    confirmButtonText: 'OK',
                });
            }
        } else {
            setSwalProps({
                show: true,
                icon: 'info',
                html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                showConfirmButton: true,
                confirmButtonColor: '#0d6efd',
                confirmButtonText: 'OK',
            });
        }
    }

    async function topupPackage() {

        let users = []
        dataImports.forEach(item => {
            users.push({
                username: item.Username,
                from: item.From
            })
        })

        let packageType = ''
        if (dataInput.packageType === 'Plus')
            packageType = 'd3bd872c-e79e-44bb-baaf-7d9be5a22651'
        else if (dataInput.packageType === 'Farm')
            packageType = 'f1096c8c-b897-4dd2-94a8-0ccdf64333c3'



        let body = {
            usernames: users,
            packageId: packageType,
            unit: dataInput.unit,
            value: dataInput.value
        }

        setIsLoading(true)

        ManagePackageService.topupPackage(body).then(result => {
            if (result.status === 201) {
                setIsLoading(false)
                setResultTopup(result.data)

                setSwalProps({
                    show: true,
                    icon: 'success',
                    html: 'ดำเนินการสำเร็จ',
                    showConfirmButton: true,
                    confirmButtonColor: '#0d6efd',
                    confirmButtonText: 'OK',
                });
            }
        }).catch(err => {
            setIsLoading(false)


            if (err.status === 401) {
                navigate('/login')
            }

        })

    }

    function importExcel(e) {


        var selectedFile = e.target.files[0]

        var reader = new FileReader()
        reader.onload = function (event) {

            var data = event.target.result
            var workbook = XLSX.read(data, {
                type: 'binary',
            })

            workbook.SheetNames.forEach(function (sheetName) {
                if (sheetName === 'Template') {
                    var row = XLSX.utils.sheet_to_row_object_array(
                        workbook.Sheets[sheetName]
                    )

                    // console.log(row)
                    var itemRows = []
                    for (let i = 0; i < row.length; i++) {

                        // if (row[i].Username.length === 10 && row[i].From !== undefined && row[i].From.trim() !== '') {
                        row[i].status = 'Ready'
                        // }
                        // else {
                        //     row[i].status = 'NotReady'
                        // }
                        itemRows.push(row[i])
                    }

                    setDataImports(itemRows)
                }
            })
        }
        reader.readAsBinaryString(selectedFile)
    }


    async function onDownloadTemplate() {
        let workbook = new Workbook()
        let worksheet = workbook.addWorksheet('Template')

        //// SET UP HEADER TEXT  AND STYLE ////
        var headerTexts = ['Username', 'From']
        var examples1 = ['09xxxxxxxx', 'Special-Free']
        var examples2 = ['09xxxxxxxx', 'RAOT-TEST']



        worksheet.getRow(1).values = headerTexts
        worksheet.getRow(2).values = examples1
        worksheet.getRow(3).values = examples2


        workbook.xlsx.writeBuffer().then(data => {
            let blob = new Blob([data], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            fs.saveAs(blob, 'Template')
        })
    }

}

export default ManagePackage